import styled, { css } from 'styled-components';
export const StyledSection = styled.section<{
    $fullOnMobile?: boolean;
    $customPadding?: string;
    $paddingBottomNone?: boolean;
    $paddingTopNone?: boolean;
    $background?: 'green' | 'gray';
    $gap?: string;
}>`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${props => (props.$gap ? props.$gap : '50px')};
    /* padding: 3.12rem 0; */
    padding: ${props => (props.$customPadding ? props.$customPadding : '3.12rem 0')};
    flex-direction: column;

    ${props =>
        props.$background === 'green' &&
        css`
            &:before {
                content: '';
                position: absolute;
                height: 100%;
                top: 0px;
                width: 100vw;
                margin-left: 50%;
                left: -50vw;
                z-index: -2;
                background-color: #1aac7a;
            }
        `}

    @media (max-width: 780px) {
        margin: ${props => props.$fullOnMobile && '0 -15px;'};
        gap: ${props => props.$fullOnMobile && '0'};
        padding-bottom: ${props => props.$paddingBottomNone && '0px;'};
        padding-top: ${props => props.$paddingBottomNone && '0px;'};
    }
`;
